import React, {
  useEffect,
  useMemo,
  useState,
} from "react";
import { Link } from "react-router-dom";

// ======================================================
// LOCAL IMAGES
// ======================================================

import lavv from "../../assets/img/lavv.png";
import mangal from "../../assets/img/mangal.png";

import endirimli from "../../assets/img/endirimli.png";
import qardasliq from "../../assets/img/qardasliq.png";
import set1 from "../../assets/img/set 1.png";
import set2 from "../../assets/img/set 2.png";
import set3 from "../../assets/img/set 3.png";
import set4 from "../../assets/img/set 4.png";

import saxsida from "../../assets/img/saxsida.jpeg";
import qreyfurt from "../../assets/img/qreyfurt.jpeg";

import sosisli from "../../assets/img/sosisli.png";
import fri from "../../assets/img/Frie.jpg";

import paxlava from "../../assets/img/paxlava.png";
import sokolad from "../../assets/img/sokolad.jpg";
import murebbe from "../../assets/img/mürebbe.jpg";
import meyve from "../../assets/img/meyve.png";
import cerezler from "../../assets/img/cerezler.png";
import snickers from "../../assets/img/snickers.png";
import rulet from "../../assets/img/rulet.jpg";

import cola from "../../assets/img/cola.png";
import fusetea from "../../assets/img/fusetea.png";
import bizon from "../../assets/img/bizon.png";
import redbull from "../../assets/img/redbull.png";
import meyvesiresi from "../../assets/img/meyvesiresi.png";
import sirab from "../../assets/img/sirab.png";
import ayran from "../../assets/img/Ayran.png";

import caysni from "../../assets/img/caysni.png";

// ======================================================
// WOLT
// ======================================================

const WOLT = "https://imageproxy.wolt.com/assets";

// ======================================================
// HEADER
// ======================================================

const HEADER_HEIGHT_DESKTOP = 68;
const HEADER_HEIGHT_MOBILE = 68;

// ======================================================
// MENU BUTTONS
// ======================================================

const menuButtons = [
    {
    id: "cayseti",
    label: "Çay setləri",
    icon: "🫖",
  },
    {
    id: "qelyanlar",
    label: "Qəlyan",
    icon: "💨",
  },
    {
    id: "qelyanlar_P",
    label: "Premium Qəlyan",
    icon: "👑",
  },
   {
    id: "salatlar",
    label: "Salatlar",
    icon: "🥗",
  },

    {
    id: "sorbalar",
    label: "Şorbalar",
    icon: "🍲",
  },
 
  {
    id: "saurmalar",
    label: "Şaurmalar",
    icon: "🥙",
  },
    {
    id: "doner",
    label: "Dönərlər",
    icon: "🥙",
  },

  {
    id: "firin-donerleri",
    label: "Fırın dönərləri",
    icon: "🔥",
  },
  {
    id: "burgerler",
    label: "Burgerlər",
    icon: "🍔",
  },
  {
    id: "pizza",
    label: "Pizzalar",
    icon: "🍕",
  },
  {
    id: "lahmacun",
    label: "Lahmacun",
    icon: "🫓",
  },

  {
    id: "pide",
    label: "Pide 15x40 sm",
    icon: "🥖",
  },
  {
    id: "kofte",
    label: "Köftələr",
    icon: "🍖",
  },
 {
    id: "qarnirler",
    label: "Qarnirlər",
    icon: "🍟",
  },
  {
    id: "desertler",
    label: "Desertlər",
    icon: "🍰",
  },
 
  {
    id: "serinicki",
    label: "Sərin içkilər",
    icon: "🥤",
  },
  {
    id: "istiicki",
    label: "İsti içkilər",
    icon: "☕",
  },
  
];

// ======================================================
// PRODUCT CARD
// ======================================================

const ProductCard = ({
  image,
  name,
  price,
  description,
  campaign = false,
  objectContain = false,
  darkMode = true,
}) => {
  const theme = darkMode
    ? {
        card: campaign
          ? `
              border-[#d6b36a]/60
              bg-gradient-to-br
              from-[#3b2a14]
              via-[#171018]
              to-[#0b0710]
              shadow-[0_18px_55px_rgba(0,0,0,0.32)]
            `
          : `
              border-white/[0.07]
              bg-[#100b15]
              shadow-[0_18px_50px_rgba(0,0,0,0.30)]
              hover:border-[#d6b36a]/30
            `,

        title: campaign
          ? "text-[#fff7e8]"
          : "text-[#f8f1e8]",

        description: campaign
          ? "text-[#cbbdca]"
          : "text-[#9f93a0]",

        imageBox: `
          border-[#d6b36a]/15
          bg-[#0a0710]
          shadow-[0_10px_30px_rgba(0,0,0,0.30)]
        `,

        price: `
          border-[#d6b36a]/25
          bg-[#d6b36a]/5
          text-[#e8c77e]
        `,

        campaignBadge: `
          border-[#d6b36a]/40
          bg-[#d6b36a]/10
          text-[#f0d69c]
        `,
      }
    : {
        card: campaign
          ? `
              border-[#d6b36a]/60
              bg-gradient-to-br
              from-[#fff9e9]
              via-white
              to-[#f5eee0]
              shadow-[0_15px_45px_rgba(15,23,42,0.09)]
            `
          : `
              border-slate-200
              bg-white
              shadow-[0_12px_35px_rgba(15,23,42,0.07)]
              hover:border-[#d6b36a]/50
              hover:shadow-[0_18px_45px_rgba(15,23,42,0.11)]
            `,

        title: campaign
          ? "text-slate-900"
          : "text-slate-800",

        description: campaign
          ? "text-slate-500"
          : "text-slate-500",

        imageBox: `
          border-slate-200
          bg-slate-50
          shadow-[0_8px_25px_rgba(15,23,42,0.08)]
        `,

        price: `
          border-[#d6b36a]/25
          bg-[#d6b36a]/5
          text-[#946b29]
        `,

        campaignBadge: `
          border-[#d6b36a]/40
          bg-[#d6b36a]/10
          text-[#946b29]
        `,
      };

  return (
    <article
      className={`
        group
        relative
        overflow-hidden
        rounded-[22px]
        border
        p-3
        transition-all
        duration-300
        hover:-translate-y-1
        sm:p-4
        ${theme.card}
      `}
    >
      {/* GOLD LINE */}

      <div
        className="
          absolute
          left-6
          right-6
          top-0
          h-px
          bg-gradient-to-r
          from-transparent
          via-[#d6b36a]/50
          to-transparent
        "
      />

      {/* GLOW */}

      <div
        className="
          pointer-events-none
          absolute
          -right-12
          -top-12
          h-32
          w-32
          rounded-full
          bg-[#d6b36a]/10
          blur-3xl
          transition-all
          duration-500
          group-hover:bg-[#d6b36a]/20
        "
      />

      <div
        className="
          relative
          grid
          min-h-[142px]
          grid-cols-[minmax(0,1fr)_108px]
          items-center
          gap-3
          sm:min-h-[165px]
          sm:grid-cols-[minmax(0,1fr)_145px]
          sm:gap-5
        "
      >
        {/* INFO */}

        <div className="min-w-0">
          {campaign && (
            <div
              className={`
                mb-2
                inline-flex
                items-center
                gap-1.5
                rounded-full
                border
                px-2.5
                py-1
                text-[8px]
                font-black
                tracking-[0.08em]
                sm:text-[9px]
                ${theme.campaignBadge}
              `}
            >
              <span
                className="
                  h-1.5
                  w-1.5
                  rounded-full
                  bg-emerald-500
                  shadow-[0_0_8px_rgba(52,211,153,.8)]
                "
              />

              XÜSUSİ TƏKLİF
            </div>
          )}

          <h3
            className={`
              line-clamp-2
              text-[14px]
              font-extrabold
              leading-[1.35]
              sm:text-[16px]
              ${theme.title}
            `}
          >
            {name}
          </h3>

          {description && (
            <p
              className={`
                mt-1.5
                line-clamp-3
                text-[10px]
                leading-[1.5]
                sm:text-[11px]
                ${theme.description}
              `}
            >
              {description}
            </p>
          )}

          {campaign ? (
            <div className="mt-3 flex items-end gap-2">
              <del
                className="
                  text-sm
                  font-bold
                  text-red-400/80
                  sm:text-base
                "
              >
                {price.old}
              </del>

              <strong
                className="
                  text-[22px]
                  font-black
                  leading-none
                  text-emerald-500
                  sm:text-[25px]
                "
              >
                {price.new}
              </strong>
            </div>
          ) : (
            <div
              className={`
                mt-3
                inline-flex
                items-center
                rounded-full
                border
                px-2.5
                py-1
                font-serif
                text-[15px]
                font-black
                tracking-wide
                sm:text-[17px]
                ${theme.price}
              `}
            >
              {price}
            </div>
          )}
        </div>

        {/* IMAGE */}

        <div className="relative">
          <div
            className="
              absolute
              inset-0
              rounded-[18px]
              bg-[#d6b36a]/10
              blur-xl
              opacity-0
              transition-opacity
              duration-500
              group-hover:opacity-100
            "
          />

          <div
            className={`
              relative
              overflow-hidden
              rounded-[18px]
              border
              ${theme.imageBox}
            `}
          >
            <img
              src={image}
              alt={name}
              loading="lazy"
              draggable="false"
              className={`
                h-[105px]
                w-full
                transition-transform
                duration-500
                group-hover:scale-105
                sm:h-[130px]
                ${
                  objectContain
                    ? "object-contain p-2.5"
                    : "object-cover"
                }
              `}
            />

            <div
              className={`
                pointer-events-none
                absolute
                inset-0
                ${
                  darkMode
                    ? "bg-gradient-to-tr from-transparent to-white/5"
                    : "bg-gradient-to-tr from-black/5 via-transparent to-white/30"
                }
              `}
            />
          </div>
        </div>
      </div>
    </article>
  );
};

// ======================================================
// SECTION
// ======================================================

const MenuSection = ({
  id,
  title,
  icon,
  children,
  darkMode = true,
}) => {
  return (
    <section
      id={id}
      className="
        scroll-mt-[145px]
        px-3
        py-5
        sm:px-5
        sm:py-7
        md:py-9
      "
    >
      <div className="mx-auto w-full max-w-[1180px]">
        {/* TITLE */}

        <div className="mb-5 sm:mb-6">
          <div className="flex items-end gap-3">
            <div
              className={`
                flex
                h-10
                w-10
                shrink-0
                items-center
                justify-center
                rounded-xl
                border
                border-[#d6b36a]/25
                bg-[#d6b36a]/10
                text-lg
                shadow-[0_8px_25px_rgba(214,179,106,0.08)]
                sm:h-12
                sm:w-12
                ${
                  darkMode
                    ? "text-[#f0d69c]"
                    : "text-[#946b29]"
                }
              `}
            >
              {icon}
            </div>

            <div className="min-w-0">
              <div
                className={`
                  mb-1
                  text-[8px]
                  font-black
                  uppercase
                  tracking-[0.3em]
                  sm:text-[9px]
                  ${
                    darkMode
                      ? "text-[#d6b36a]"
                      : "text-[#a77c35]"
                  }
                `}
              >
                FF QADİR · MENYU
              </div>

              <h2
                className={`
                  font-serif
                  text-[25px]
                  font-black
                  tracking-tight
                  sm:text-[33px]
                  ${
                    darkMode
                      ? "text-[#f7f0e5]"
                      : "text-slate-900"
                  }
                `}
              >
                {title}
              </h2>
            </div>
          </div>

          <div
            className="
              mt-4
              h-px
              w-full
              bg-gradient-to-r
              from-[#d6b36a]/50
              via-[#d6b36a]/10
              to-transparent
            "
          />
        </div>

        {/* PRODUCTS */}

        <div
          className="
            grid
            grid-cols-1
            gap-3
            min-[720px]:grid-cols-2
            min-[720px]:gap-4
            lg:gap-5
          "
        >
          {children}
        </div>
      </div>
    </section>
  );
};

// ======================================================
// MENYU
// ======================================================

const Menyu = () => {
  const [activeSection, setActiveSection] =
    useState("cayseti"); 

  const [darkMode, setDarkMode] = useState(() => {
    if (typeof window === "undefined") {
      return true;
    }

    const saved = localStorage.getItem(
      "theme"
    );

    if (saved === "light") return false;

    if (saved === "dark") return true;

    return true;
  });

  const [showTopButton, setShowTopButton] =
    useState(false);

  // ====================================================
  // THEME
  // ====================================================

  useEffect(() => {
    localStorage.setItem(
      "theme",
      darkMode ? "dark" : "light"
    );
  }, [darkMode]);

  // ====================================================
  // TOP BUTTON
  // ====================================================

  useEffect(() => {
    const handleScroll = () => {
      setShowTopButton(
        window.scrollY > 500
      );
    };

    handleScroll();

    window.addEventListener(
      "scroll",
      handleScroll,
      {
        passive: true,
      }
    );

    return () => {
      window.removeEventListener(
        "scroll",
        handleScroll
      );
    };
  }, []);

  // ====================================================
  // SCROLL TOP
  // ====================================================

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // ====================================================
  // SCROLL TO SECTION
  // ====================================================

  const scrollToSection = (sectionId) => {
    const section =
      document.getElementById(sectionId);

    if (!section) return;

    const isMobile =
      window.innerWidth < 768;

    const offset = isMobile
      ? 18
      : HEADER_HEIGHT_DESKTOP + 12;

    const top =
      section.getBoundingClientRect().top +
      window.scrollY -
      offset;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: "smooth",
    });
  };

  // ====================================================
  // ACTIVE SECTION
  // ====================================================

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(() => {
        const isMobile =
          window.innerWidth < 768;

        const headerOffset = isMobile
          ? 80
          : HEADER_HEIGHT_DESKTOP + 85;

        const position =
          window.scrollY + headerOffset;

        let current = "cayseti";

        for (const item of menuButtons) {
          const section =
            document.getElementById(item.id);

          if (!section) continue;

          const top = section.offsetTop;

          const bottom =
            top + section.offsetHeight;

          if (
            position >= top &&
            position < bottom
          ) {
            current = item.id;
            break;
          }
        }

        setActiveSection(
          (previous) =>
            previous === current
              ? previous
              : current
        );

        ticking = false;
      });
    };

    handleScroll();

    window.addEventListener(
      "scroll",
      handleScroll,
      {
        passive: true,
      }
    );

    window.addEventListener(
      "resize",
      handleScroll
    );

    return () => {
      window.removeEventListener(
        "scroll",
        handleScroll
      );

      window.removeEventListener(
        "resize",
        handleScroll
      );
    };
  }, []);

  // ====================================================
  // ACTIVE CATEGORY AUTO SCROLL
  // ====================================================

  useEffect(() => {
    const menu =
      document.getElementById(
        "category-scroll"
      );

    const button =
      document.querySelector(
        `[data-menu-id="${activeSection}"]`
      );

    if (!menu || !button) return;

    const left =
      menu.scrollLeft;

    const right =
      left + menu.clientWidth;

    const buttonLeft =
      button.offsetLeft;

    const buttonRight =
      buttonLeft +
      button.offsetWidth;

    if (buttonLeft < left) {
      menu.scrollTo({
        left: Math.max(
          0,
          buttonLeft - 15
        ),
        behavior: "smooth",
      });
    } else if (
      buttonRight > right
    ) {
      menu.scrollTo({
        left:
          buttonRight -
          menu.clientWidth +
          15,
        behavior: "smooth",
      });
    }
  }, [activeSection]);

  // ====================================================
  // SECTIONS DATA
  // ====================================================

  const sections = useMemo(
    () => ({
      saurmalar: [
        {
          name: "Şaurma Toyuq Çörəkdə/Lavaşda",
          price: "6.00 ₼",
          image: `${WOLT}/66c90e901cb8937705147e81?w=600`,
        },
        {
          name: "Şaurma Ət Çörəkdə/Lavaşda",
          price: "7.00 ₼",
          image: `${WOLT}/66c90ed616f38b5370fe2bd9?w=600`,
        },
        {
          name: "Şaurma Toyuq qabda",
          price: "10.00 ₼",
          image: `${WOLT}/66c912a51004893400013f96?w=600`,
        },
        {
          name: "Şaurma Ət qabda",
          price: "11.00 ₼",
          image: `${WOLT}/66c912c70f371b1d2f5ba4ae?w=600`,
        },
      ],

      firinDonerleri: [
        {
          name: "Fırında Toyuq Dönəri Çörəkdə",
          price: "8.00 ₼",
          image: `${WOLT}/66c90bce1cb8937705147e7d?w=600`,
        },
        {
          name: "Fırında Ət Dönəri Çörəkdə",
          price: "9.00 ₼",
          image: `${WOLT}/66c90c530f371b1d2f5ba4a7?w=600`,
        },
      ],

      doner: [
        {
          name: "Toyuq Dönəri Çörəkdə",
          price: "4.50 ₼",
          image: `${WOLT}/66c913400d61160c8817200b?w=600`,
        },
        {
          name: "Toyuq Dönəri Lavaşda",
          price: "4.90 ₼",
          image: lavv,
        },
        {
          name: "Ət Dönəri Çörəkdə",
          price: "4.90 ₼",
          image: `${WOLT}/66c915120f371b1d2f5ba4b0?w=600`,
        },
        {
          name: "Ət Dönəri Lavaşda",
          price: "4.90 ₼",
          image: lavv,
        },
        {
          name: "Pendirli Toyuq Dönəri",
          price: "5.50 ₼",
          image: `${WOLT}/66c9181fb055dc08c413fde9?w=600`,
        },
        {
          name: "Pendirli Ət Dönəri",
          price: "6.00 ₼",
          image: `${WOLT}/66c9199516f38b5370fe2bdb?w=600`,
        },
        {
          name: "Basdırma Toyuq ilə",
          price: "5.00 ₼",
          image: `${WOLT}/66c91b860d61160c8817200d?w=600`,
        },
        {
          name: "Basdırma Ət ilə",
          price: "5.50 ₼",
          image: `${WOLT}/66c91bb91004893400013f98?w=600`,
        },
        {
          name: "Plovüstü Toyuq",
          price: "10.00 ₼",
          image: `${WOLT}/66c91f8c0d61160c88172011?w=600`,
        },
        {
          name: "Plovüstü Ət",
          price: "11.00 ₼",
          image: `${WOLT}/66c92002b055dc08c413fdec?w=600`,
        },
        {
          name: "Porsion Toyuq",
          price: "10.00 ₼",
          image: `${WOLT}/66c920b41004893400013f99?w=600`,
        },
        {
          name: "Porsion Ət",
          price: "11.00 ₼",
          image: `${WOLT}/66c921610f371b1d2f5ba4b2?w=600`,
        },
        {
          name: "İskəndər Ət",
          price: "13.00 ₼",
          image: `${WOLT}/66c92731b055dc08c413fded?w=600`,
        },
        {
          name: "Tombik Toyuq",
          price: "5.50 ₼",
          image: `${WOLT}/66c9bc5db055dc08c413fe82?w=600`,
        },
        {
          name: "Tombik Ət",
          price: "6.00 ₼",
          image: `${WOLT}/66c9bc3e1cb8937705147f47?w=600`,
        },
      ],

      sorbalar: [
        {
          name: "Mərci Şorbası",
          price: "4.50 ₼",
          image: `${WOLT}/66c9de32b055dc08c413ff46?w=600`,
        },
        {
          name: "Toyuq Şorbası",
          price: "5.50 ₼",
          image: `${WOLT}/66c9e00516f38b5370fe2ce5?w=600`,
        },
        {
          name: "Göbələk Şorbası",
          price: "5.50 ₼",
          image: `${WOLT}/66c9e0f40d61160c88172112?w=600`,
        },
        {
          name: "Tomat Şorbası",
          price: "5.50 ₼",
          image: `${WOLT}/66c9df291cb8937705147ff2?w=600`,
        },
        {
          name: "Düşbərə Şorbası",
          price: "6.00 ₼",
          image: `${WOLT}/66c9de960f371b1d2f5ba5cf?w=600`,
        },
      ],

      salatlar: [
        {
          name: "Toyuq Salatı",
          price: "5.50 ₼",
          image: `${WOLT}/66c9e284b055dc08c413ff52?w=600`,
        },
        {
          name: "Yunan Salatı",
          price: "5.50 ₼",
          image: `${WOLT}/66c9e300b055dc08c413ff53?w=600`,
        },
        {
          name: "Manqal Salatı",
          price: "5.50 ₼",
          image: mangal,
        },
        {
          name: "Mimoza Salatı",
          price: "5.50 ₼",
          image: `${WOLT}/66c9e24db055dc08c413ff51?w=600`,
        },
      ],

      kofte: [
        {
          name: "Toyuq Köftə",
          price: "5.00 ₼",
          image: `${WOLT}/66c9bde716f38b5370fe2c9c?w=600`,
        },
        {
          name: "Ət Köftə",
          price: "6.00 ₼",
          image: `${WOLT}/66c9be36b055dc08c413fe86?w=600`,
        },
        {
          name: "Köftə Porsion Toyuq",
          price: "10.00 ₼",
          image: `${WOLT}/66c9d08016f38b5370fe2cab?w=600`,
        },
        {
          name: "Köftə Porsion Ət",
          price: "11.00 ₼",
          image: `${WOLT}/66c9d14c0f371b1d2f5ba591?w=600`,
        },
      ],

      burgerler: [
        {
          name: "Toyuq Burger",
          price: "8.00 ₼",
          image: `${WOLT}/66c90a1416f38b5370fe2bce?w=600`,
        },
        {
          name: "Ət Burger",
          price: "9.00 ₼",
          image: `${WOLT}/66c90a8f0f371b1d2f5ba4a3?w=600`,
        },
        {
          name: "Cheeseburger Toyuq",
          price: "9.00 ₼",
          image: `${WOLT}/66c90b1316f38b5370fe2bd1?w=600`,
        },
        {
          name: "Cheeseburger Ət",
          price: "10.00 ₼",
          image: `${WOLT}/66c90b470d61160c88171ff9?w=600`,
        },
      ],

      lahmacun: [
        {
          name: "Sadə Lahmacun",
          price: "4.00 ₼",
          image: `${WOLT}/66c9da9c16f38b5370fe2cd9?w=600`,
        },
        {
          name: "Pendirli Lahmacun",
          price: "4.50 ₼",
          image: `${WOLT}/66c9dbeb1cb8937705147fd8?w=600`,
        },
      ],

      pide: [
        {
          name: "Qiyməli Pide",
          price: "9.00 ₼",
          image: `${WOLT}/66c9d8391004893400014067?w=600`,
        },
        {
          name: "Sucuklu Pide",
          price: "11.00 ₼",
          image: `${WOLT}/66c9d9910f371b1d2f5ba5ab?w=600`,
        },
        {
          name: "Yumurtalı Pide",
          price: "10.50 ₼",
          image: `${WOLT}/66c9d9f616f38b5370fe2cd6?w=600`,
        },
        {
          name: "Toyuqlu Pide",
          price: "11.00 ₼",
          image: `${WOLT}/66c9d9bcb055dc08c413ff1c?w=600`,
        },
        {
          name: "Qarışıq Pide",
          price: "12.00 ₼",
          image: `${WOLT}/66c9da6b1cb8937705147f9f?w=600`,
        },
      ],

      pizza: [
        {
          name: "Marqarita Pizza",
          price: "11.00 ₼",
          image: `${WOLT}/66c9d71a1004893400014065?w=600`,
        },
        {
          name: "Toyuqlu Pizza",
          price: "13.00 ₼",
          image: `${WOLT}/66c9d76216f38b5370fe2ccb?w=600`,
        },
        {
          name: "Vegetarian Pizza",
          price: "13.00 ₼",
          image: `${WOLT}/66c9d7001004893400014064?w=600`,
        },
        {
          name: "Meksikano Pizza",
          price: "13.00 ₼",
          image: `${WOLT}/66c9d692b055dc08c413ff11?w=600`,
        },
        {
          name: "4 Pendirli Pizza",
          price: "13.00 ₼",
          image: `${WOLT}/66c9d5d40f371b1d2f5ba597?w=600`,
        },
        {
          name: "İtaliano Pizza",
          price: "13.00 ₼",
          image: `${WOLT}/66c9d62216f38b5370fe2cc5?w=600`,
        },
        {
          name: "Pepperoni Pizza",
          price: "13.00 ₼",
          image: `${WOLT}/66c9d64416f38b5370fe2cc6?w=600`,
        },
        {
          name: "Sosisli Pizza",
          price: "13.00 ₼",
          image: sosisli,
        },
        {
          name: "Uşaqlar üçün Pizza",
          price: "13.00 ₼",
          image: `${WOLT}/66c9d4320d61160c881720e5?w=600`,
        },
        {
          name: "Qarışıq Pizza",
          price: "14.00 ₼",
          image: `${WOLT}/66c9d74716f38b5370fe2cca?w=600`,
        },
        {
          name: "American Hot Pizza",
          price: "14.00 ₼",
          image: `${WOLT}/66c9357d1cb8937705147e86?w=600`,
        },
        {
          name: "BBQ Chicken Pizza",
          price: "14.00 ₼",
          image: `${WOLT}/66c9354fb055dc08c413fdf0?w=600`,
        },
      ],
    }),
    []
  );

  // ====================================================
  // SECTION HELPER
  // ====================================================

  const renderSection = (
    id,
    title,
    icon,
    children
  ) => (
    <MenuSection
      id={id}
      title={title}
      icon={icon}
      darkMode={darkMode}
    >
      {children}
    </MenuSection>
  );

  // ====================================================
  // RENDER
  // ====================================================

  return (
    <main
      className={`
        min-h-screen
        w-full
        overflow-x-hidden
        antialiased
        transition-colors
        duration-500

        ${
          darkMode
            ? "bg-[#05030a] text-white"
            : "bg-[#f5f3ef] text-slate-900"
        }
      `}
    >
      {/* ==================================================
          HEADER
      ================================================== */}

      <header
        className={`
          fixed
          left-0
          right-0
          top-0
          z-[10000]
          border-b
          backdrop-blur-2xl
          transition-colors
          duration-500

          ${
            darkMode
              ? `
                border-white/[0.06]
                bg-[#08050d]/95
                shadow-[0_12px_40px_rgba(0,0,0,0.4)]
              `
              : `
                border-slate-200
                bg-white/95
                shadow-[0_8px_30px_rgba(15,23,42,0.07)]
              `
          }
        `}
      >
        <div
          className="
            mx-auto
            flex
            h-[68px]
            w-full
            max-w-[1380px]
            items-center
            gap-2
            px-3
            sm:px-5
            lg:px-7
          "
        >
          {/* BACK */}

          <Link
            to="/"
            className={`
              group
              flex
              h-10
              shrink-0
              items-center
              gap-1.5
              rounded-xl
              border
              px-2.5
              transition-all
              duration-300
              sm:h-11
              sm:gap-2
              sm:px-3.5

              ${
                darkMode
                  ? `
                    border-white/[0.08]
                    bg-white/[0.025]
                    text-white/70
                    hover:border-[#d6b36a]/50
                    hover:text-[#f0d69c]
                  `
                  : `
                    border-slate-200
                    bg-slate-50
                    text-slate-700
                    hover:border-[#d6b36a]/50
                    hover:text-[#966d2b]
                  `
              }
            `}
          >
            <span className="text-lg transition-transform group-hover:-translate-x-1">
              ←
            </span>

            <span className="hidden text-[10px] font-black uppercase tracking-[0.12em] min-[430px]:block sm:text-[11px]">
              Sayta qayıt
            </span>
          </Link>

          {/* TITLE */}

          <div className="min-w-0 flex-1 text-center">
            <div
              className={`
                text-[7px]
                font-black
                uppercase
                tracking-[0.35em]
                sm:text-[8px]
                ${
                  darkMode
                    ? "text-[#d6b36a]"
                    : "text-[#a77c35]"
                }
              `}
            >
              FF QADİR
            </div>

            <div
              className={`
                truncate
                font-serif
                text-[17px]
                font-black
                leading-none
                sm:text-[21px]
                ${
                  darkMode
                    ? "text-[#fff8eb]"
                    : "text-slate-900"
                }
              `}
            >
              LOUNGE MENU
            </div>
          </div>

          {/* THEME */}

          <button
            type="button"
            onClick={() =>
              setDarkMode(
                (previous) => !previous
              )
            }
            className={`
              flex
              h-10
              w-10
              shrink-0
              items-center
              justify-center
              rounded-xl
              border
              border-[#d6b36a]/30
              bg-[#d6b36a]/10
              text-lg
              shadow-[0_5px_20px_rgba(214,179,106,0.08)]
              transition-all
              hover:scale-105
              sm:h-11
              sm:w-11

              ${
                darkMode
                  ? "text-[#f0d69c]"
                  : "text-[#98702e]"
              }
            `}
            aria-label="Tema dəyiş"
          >
            {darkMode ? "☀" : "☾"}
          </button>
        </div>
      </header>

      {/* HEADER SPACE */}

      <div className="h-[68px]" />

      {/* ==================================================
          CATEGORY BAR
      ================================================== */}

      <nav
        className={`
          fixed
          bottom-0
          left-0
          right-0
          z-[9999]
          border-t
          px-2
          pb-[calc(7px+env(safe-area-inset-bottom))]
          pt-2
          backdrop-blur-2xl
          transition-colors
          duration-500

          md:bottom-auto
          md:top-[68px]
          md:border-t-0
          md:border-b
          md:px-0
          md:pb-0
          md:pt-0

          ${
            darkMode
              ? `
                border-white/[0.06]
                bg-[#08050d]/96
                shadow-[0_-12px_45px_rgba(0,0,0,0.5)]
                md:shadow-[0_8px_35px_rgba(0,0,0,0.4)]
              `
              : `
                border-slate-200
                bg-white/95
                shadow-[0_8px_35px_rgba(15,23,42,0.10)]
              `
          }
        `}
      >
        <div
          id="category-scroll"
          className="
            mx-auto
            flex
            max-w-[1380px]
            gap-2
            overflow-x-auto
            px-1
            py-1
            md:px-5
            md:py-2.5
            lg:px-7
          "
          style={{
            scrollbarWidth: "none",
            WebkitOverflowScrolling:
              "touch",
            touchAction: "pan-x",
          }}
        >
          {menuButtons.map((item) => {
            const isActive =
              activeSection === item.id;

            return (
              <button
                key={item.id}
                type="button"
                data-menu-id={item.id}
                onClick={() =>
                  scrollToSection(item.id)
                }
                className={`
                  flex
                  min-h-[38px]
                  shrink-0
                  items-center
                  gap-1.5
                  rounded-full
                  border
                  px-3
                  text-[10px]
                  font-extrabold
                  whitespace-nowrap
                  transition-all
                  duration-300
                  sm:min-h-[41px]
                  sm:px-3.5
                  sm:text-[11px]

                  ${
                    isActive
                      ? `
                        border-[#d6b36a]
                        bg-gradient-to-r
                        from-[#ead39b]
                        to-[#c69d55]
                        text-[#21151b]
                        shadow-[0_6px_20px_rgba(214,179,106,0.24)]
                      `
                      : darkMode
                      ? `
                        border-white/[0.07]
                        bg-white/[0.025]
                        text-white/55
                        hover:border-[#d6b36a]/40
                        hover:bg-[#d6b36a]/10
                        hover:text-[#f0d69c]
                      `
                      : `
                        border-slate-200
                        bg-slate-50
                        text-slate-600
                        hover:border-[#d6b36a]/40
                        hover:bg-[#d6b36a]/10
                        hover:text-[#91692a]
                      `
                  }
                `}
              >
                <span className="text-[12px]">
                  {item.icon}
                </span>

                {item.label}
              </button>
            );
          })}
        </div>
      </nav>

      {/* ==================================================
          CONTENT
      ================================================== */}

      <div
        className="
          relative
          z-10
          md:pt-[66px]
          pb-[80px]
          md:pb-0
        "
      >
        {/* ==================================================
            CAY SETLERI
        ================================================== */}

        {renderSection(
          "cayseti",
          "Çay Setləri",
          "🫖",
          <>
            <ProductCard
              darkMode={darkMode}
              campaign
              image={endirimli}
              name="Endirimli Çay Seti"
              description="Çay, 1 ədəd rulet və qəlyan"
              price={{
                old: "29.00 ₼",
                new: "13.90 ₼",
              }}
            />

            <ProductCard
              darkMode={darkMode}
              image={qardasliq}
              name="Qardaşlıq Seti"
              description="Çay, Mürəbbə, Türk paxlavası, Çaşkada qəlyan (2 ədəd)"
              price="29.00 ₼"
            />

            <ProductCard
              darkMode={darkMode}
              image={set1}
              name="Set 1"
              description="Çay, Mürəbbə, Türk paxlavası, Rulet"
              price="14.00 ₼"
            />

            <ProductCard
              darkMode={darkMode}
              image={set2}
              name="Set 2"
              description="Çay, Mürəbbə, Türk paxlavası, Çaşkada qəlyan"
              price="19.00 ₼"
            />

            <ProductCard
              darkMode={darkMode}
              image={set3}
              name="Set 3"
              description="Çay (2 ədəd), Mürəbbə, Türk paxlavası, Snikers, Rulet, Qreyfurtda qəlyan"
              price="29.00 ₼"
            />

            <ProductCard
              darkMode={darkMode}
              image={set4}
              name="Set 4"
              description="Çay (limitsiz), Mürəbbə (2 ədəd), Alpen Gold, Türk paxlavası, Snikers, Rulet, Çərəz dəsti, Ananasda qəlyan"
              price="65.00 ₼"
            />
          </>
        )}

        {/* ==================================================
            QELYANLAR
        ================================================== */}

        {renderSection(
          "qelyanlar",
          "Qəlyanlar",
          "💨",
          <>
            <ProductCard
              darkMode={darkMode}
              image={saxsida}
              name="Saxsıda qəlyan"
              price="15.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={qreyfurt}
              name="Qreyfurtda qəlyan"
              price="20.00 ₼"
              objectContain
            />
          </>
        )}

          {renderSection(
          "qelyanlar_P",
          "Premium Tütün ilə",
          "👑",
          <>
            <ProductCard
              darkMode={darkMode}
              image={saxsida}
              name="Saxsıda qəlyan"
              price="25.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={qreyfurt}
              name="Qreyfurtda qəlyan"
              price="30.00 ₼"
              objectContain
            />
          </>
        )}

        {/* ==================================================
            SALATLAR
        ================================================== */}

        {renderSection(
          "salatlar",
          "Salatlar",
          "🥗",
          sections.salatlar.map(
            (item) => (
              <ProductCard
                key={item.name}
                {...item}
                darkMode={darkMode}
              />
            )
          )
        )}

        {/* ==================================================
            SORBALAR
        ================================================== */}

        {renderSection(
          "sorbalar",
          "Şorbalar",
          "🍲",
          sections.sorbalar.map(
            (item) => (
              <ProductCard
                key={item.name}
                {...item}
                darkMode={darkMode}
              />
            )
          )
        )}

        {/* ==================================================
            SAURMALAR
        ================================================== */}

        {renderSection(
          "saurmalar",
          "Şaurmalar",
          "🥙",
          sections.saurmalar.map(
            (item) => (
              <ProductCard
                key={item.name}
                {...item}
                darkMode={darkMode}
              />
            )
          )
        )}

        {/* ==================================================
            DONER
        ================================================== */}

        {renderSection(
          "doner",
          "Dönərlər",
          "🥙",
          sections.doner.map(
            (item) => (
              <ProductCard
                key={item.name}
                {...item}
                darkMode={darkMode}
              />
            )
          )
        )}

        {/* ==================================================
            FIRIN DONERLERI
        ================================================== */}

        {renderSection(
          "firin-donerleri",
          "Fırın Dönərləri",
          "🔥",
          sections.firinDonerleri.map(
            (item) => (
              <ProductCard
                key={item.name}
                {...item}
                darkMode={darkMode}
              />
            )
          )
        )}

        {/* ==================================================
            BURGERLER
        ================================================== */}

        {renderSection(
          "burgerler",
          "Burgerlər",
          "🍔",
          sections.burgerler.map(
            (item) => (
              <ProductCard
                key={item.name}
                {...item}
                darkMode={darkMode}
              />
            )
          )
        )}

        {/* ==================================================
            PIZZA
        ================================================== */}

        {renderSection(
          "pizza",
          "Pizza 30 sm",
          "🍕",
          sections.pizza.map(
            (item) => (
              <ProductCard
                key={item.name}
                {...item}
                darkMode={darkMode}
              />
            )
          )
        )}

        {/* ==================================================
            LAHMACUN
        ================================================== */}

        {renderSection(
          "lahmacun",
          "Lahmacun",
          "🫓",
          <>
            <ProductCard
              darkMode={darkMode}
              image={`${WOLT}/66c9da9c16f38b5370fe2cd9?w=600`}
              name="Sadə Lahmacun"
              price="4.00 ₼"
            />

            <ProductCard
              darkMode={darkMode}
              image={`${WOLT}/66c9dbeb1cb8937705147fd8?w=600`}
              name="Pendirli Lahmacun"
              price="4.50 ₼"
            />
          </>
        )}

        {/* ==================================================
            PIDE
        ================================================== */}

        {renderSection(
          "pide",
          "Pide 15x40 sm",
          "🥖",
          sections.pide.map(
            (item) => (
              <ProductCard
                key={item.name}
                {...item}
                darkMode={darkMode}
              />
            )
          )
        )}

        {/* ==================================================
            KOFTE
        ================================================== */}

        {renderSection(
          "kofte",
          "Köftələr",
          "🍖",
          sections.kofte.map(
            (item) => (
              <ProductCard
                key={item.name}
                {...item}
                darkMode={darkMode}
              />
            )
          )
        )}

        {/* ==================================================
            QARNIRLER
        ================================================== */}

        {renderSection(
          "qarnirler",
          "Qarnirlər",
          "🍟",
          <ProductCard
            darkMode={darkMode}
            image={fri}
            name="Fri"
            price="4.00 ₼"
          />
        )}

        {/* ==================================================
            DESERTLER
        ================================================== */}

        {renderSection(
          "desertler",
          "Desertlər",
          "🍰",
          <>
            <ProductCard
              darkMode={darkMode}
              image={paxlava}
              name="Paxlava türk"
              price="6.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={sokolad}
              name="Şokolad"
              price="7.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={murebbe}
              name="Mürəbbə"
              price="8.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={meyve}
              name="Meyvə Assorti"
              price="14.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={cerezler}
              name="Qarışıq çərəzlər"
              price="10.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={snickers}
              name="Snickers"
              price="6.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={rulet}
              name="Rulet"
              price="5.00 ₼"
              objectContain
            />
          </>
        )}

        {/* ==================================================
            SERIN ICKILER
        ================================================== */}

        {renderSection(
          "serinicki",
          "Sərin İçkilər",
          "🥤",
          <>
            <ProductCard
              darkMode={darkMode}
              image={cola}
              name="Coca Cola 330 ml"
              price="4.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={fusetea}
              name="Fuse Tea 330 ml"
              price="4.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={bizon}
              name="Bizon 250 ml"
              price="2.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={redbull}
              name="Redbul"
              price="6.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={meyvesiresi}
              name="Meyvə şirəsi"
              price="5.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={sirab}
              name="Sirab (qazlı, qazsız)"
              price="3.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image={ayran}
              name="Ayran"
              price="3.00 ₼"
              objectContain
            />
          </>
        )}

        {/* ==================================================
            ISTI ICKILER
        ================================================== */}

        {renderSection(
          "istiicki",
          "İsti İçkilər",
          "☕",
          <>
            <ProductCard
              darkMode={darkMode}
              image={caysni}
              name="Çay, Snikers"
              price="8.00 ₼"
              objectContain
            />

            <ProductCard
              darkMode={darkMode}
              image="https://acdn-us.mitiendanube.com/stores/004/990/810/products/te-turco-ritual-de-hospitalidad-e-historia-590a4094889e9fb1c517297136534922-1024-1024.webp"
              name="Çay, mürəbbə"
              price="10.00 ₼"
            />

            <ProductCard
              darkMode={darkMode}
              image="https://static.wixstatic.com/media/31dd45_a030967f0bdb47de93219351ea6d092a~mv2.jpg/v1/fill/w_980,h_1470,al_c,q_85,enc_avif,quality_auto/31dd45_a030967f0bdb47de93219351ea6d092a~mv2.jpg"
              name="Əlavə çay"
              price="4.00 ₼"
            />

            <ProductCard
              darkMode={darkMode}
              image="https://cdn.shopify.com/s/files/1/1951/4281/files/guide_to_pairing_tea_and_chocolate_480x480.png?v=1676066214"
              name="Çay, AlpenGold"
              price="10.00 ₼"
            />

            <ProductCard
              darkMode={darkMode}
              image="https://afternoonteaing.com/wp-content/uploads/bb-cafe-richmond-hill.jpg"
              name="Çay, Rulet"
              price="8.00 ₼"
            />

            <ProductCard
              darkMode={darkMode}
              image="https://media.holafly.com/sites/18/2025/01/baklava-turkischer-tee-768x923.jpg"
              name="Çay, Türk paxlavası (4 ədəd)"
              price="9.00 ₼"
            />
          </>
        )}

        {/* ==================================================
            PREMIUM QELYAN
        ================================================== */}

      
      </div>

      {/* ==================================================
          GO TOP BUTTON
      ================================================== */}

      <button
        type="button"
        onClick={scrollToTop}
        aria-label="Yuxarı qalx"
        className={`
          fixed
          z-[10001]
          flex
          h-11
          w-11
          items-center
          justify-center
          rounded-full
          border
          border-[#d6b36a]/40
          bg-[#d6b36a]
          text-xl
          font-black
          text-[#20151b]
          shadow-[0_10px_30px_rgba(214,179,106,0.28)]
          transition-all
          duration-300
          hover:-translate-y-1
          hover:shadow-[0_15px_40px_rgba(214,179,106,0.4)]

          bottom-[78px]
          right-3

          md:bottom-6
          md:right-6

          ${
            showTopButton
              ? "translate-y-0 opacity-100"
              : "pointer-events-none translate-y-4 opacity-0"
          }
        `}
      >
        ↑
      </button>

      {/* ==================================================
          FOOTER
      ================================================== */}

      <footer
        className={`
          relative
          z-10
          mt-5
          border-t
          px-4
          py-6
          text-center
          transition-colors
          duration-500

          ${
            darkMode
              ? `
                border-white/[0.05]
                bg-[#030207]
              `
              : `
                border-slate-200
                bg-white
              `
          }
        `}
      >
        <div className="flex items-center justify-center gap-3">
          <span className="h-px w-8 bg-gradient-to-r from-transparent to-[#d6b36a]/40" />

          <p
            className={`
              text-[9px]
              font-semibold
              tracking-wide
              sm:text-[10px]
              ${
                darkMode
                  ? "text-white/25"
                  : "text-slate-400"
              }
            `}
          >
            © {new Date().getFullYear()} FF
            Qadir Lounge
          </p>

          <span className="h-px w-8 bg-gradient-to-l from-transparent to-[#d6b36a]/40" />
        </div>
      </footer>
    </main>
  );
};

export default Menyu;